import React, {FunctionComponent} from "react";
import {observer} from "mobx-react";
import {IconButton} from "@mui/material";
import {useStorageTranslateContext} from "@app/modules/Translate/contexts/storage";
import {useModelContext} from "@app/contexts/model";
import {faFolderOpen, faFolder} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


interface IOpenCategoryProps {
}


export const OpenCategory: FunctionComponent<IOpenCategoryProps> = observer<FunctionComponent<IOpenCategoryProps>>(function (props) {

    const {translateStore} = useStorageTranslateContext()
    const {languageFileModel} = useModelContext()

    let dataLanguageResponse = languageFileModel.dataLanguage.get()

    let disabled = !dataLanguageResponse


    /*useEffect(() => {
        let listener = () => {
            translateStore.gridApi.sizeColumnsToFit()
            console.log("ff")
        };

        if (translateStore.categoryOpen) {
            window.addEventListener('click', listener);
        } else {
            window.removeEventListener('click', listener);
        }

        return () => window.removeEventListener('click', listener);
    });*/

    return <IconButton
        disabled={disabled}
        className={translateStore.categoryOpen ? 'featureButtons__i featureButtons__i--cat' : 'featureButtons__i--cat featureButtons__i'}
        aria-hidden="true"
        title={translateStore.categoryOpen ? 'Close list of categories' : 'Open list of categories'}
        onClick={() => {
            setTimeout(() =>
                translateStore.autoSizeColumns()
            );
            translateStore.categoryOpen = !translateStore.categoryOpen;
        }}
    >
        {translateStore.categoryOpen ? <FontAwesomeIcon icon={faFolderOpen}/> :<FontAwesomeIcon icon={faFolder}/>}
    </IconButton>
});


